var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isExt(_vm.link.url))?_c('a',{class:_vm.linkClss,attrs:{"href":_vm.link.url,"target":_vm.link.target,"rel":_vm.link.target === '_blank' && 'noopener'}},[_vm._t("default")],2):_c('router-link',{class:_vm.linkClss,attrs:{"to":_vm.resolve(_vm.link.url)}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }